import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface CategoryTabsProps {
  activeSlug: string;
}

export default function CategoryTabs({ activeSlug }: CategoryTabsProps) {
  return (
    <div className="bg-background-50 border-b border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-1 overflow-x-auto py-3 no-scrollbar">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`flex items-center gap-1.5 px-4 py-2 text-sm rounded-full transition-all whitespace-nowrap cursor-pointer shrink-0 ${
                activeSlug === cat.slug
                  ? 'bg-primary-500 text-background-50 font-medium'
                  : 'bg-background-100 text-foreground-700 hover:bg-background-200'
              }`}
            >
              <i className={`${cat.icon} text-xs`}></i>
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}